module.exports = __webpack_public_path__ + "img/smallcalendar.c7056333.svg";